// extracted by mini-css-extract-plugin
export default {"tabPage":"tab_page_tabPage__sShDs","title":"tab_page_title__ZAOXy","description":"tab_page_description__3WXEj"};